import React, { useState, useEffect, useMemo } from 'react';
import { FaUndo, FaTimes } from 'react-icons/fa';
import { useAlertDialog } from '../../contexts/AlertDialogContext';

const RestoreCustomLinkModal = ({ isOpen, onClose, onRestore, link }) => {
    const [valideJusquA, setValideJusquA] = useState('');

    useEffect(() => {
        if (link && link.valide_jusqu_a) {
            setValideJusquA(link.valide_jusqu_a.split('T')[0]);
        } else {
            setValideJusquA('');
        }
    }, [link]);

    if (!isOpen || !link) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (valideJusquA) {
            const date = new Date(valideJusquA + 'T00:00:00Z');
            onRestore(link.id, date.toISOString());
            onClose();
            setValideJusquA('');
        } else {
            alert('Veuillez sélectionner une date de validité.');
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Restaurer le Lien Personnalisé</h2>
                <button onClick={onClose} className="modal-close-button"><FaTimes /></button>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Valide jusqu'au:</label>
                        <input
                            type="date"
                            name="valide_jusqu_a"
                            value={valideJusquA}
                            onChange={(e) => setValideJusquA(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="action-btn btn-save">Restaurer</button>
                </form>
            </div>
        </div>
    );
};

const DeletedLinksTable = ({ links, onRestoreLink }) => {
    const { openAlertDialog } = useAlertDialog();
    const [showRestoreCustomLinkModal, setShowRestoreCustomLinkModal] = useState(false);
    const [linkToRestore, setLinkToRestore] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const filteredLinks = useMemo(() => {
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        return links.filter(link => 
            link.ambassadeur_prenom.toLowerCase().includes(lowerCaseSearchTerm) ||
            link.ambassadeur_nom.toLowerCase().includes(lowerCaseSearchTerm) ||
            link.ambassadeur_email.toLowerCase().includes(lowerCaseSearchTerm)
        );
    }, [links, searchTerm]);

    const handleRestoreClick = (link) => {
        if (link.type_lien === 'defaut') {
            openAlertDialog(
                'Êtes-vous sûr de vouloir restaurer ce lien par défaut ?',
                'Confirmation de Restauration',
                () => onRestoreLink(link.id, null) // null for days as it's default
            );
        } else { // personnalise
            setLinkToRestore(link);
            setShowRestoreCustomLinkModal(true);
        }
    };

    return (
        <div className="deleted-links-section" style={{ marginTop: '30px' }}>
            <h3>Liens Supprimés ({filteredLinks.length})</h3>
            <div className="search-bar" style={{ marginBottom: '20px', maxWidth: '400px', margin: '20px auto' }}>
                <input
                    type="text"
                    placeholder="Rechercher par nom ou email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
                />
            </div>
            <div className="links-table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Ambassadeur</th>
                            <th>URL de Tracking</th>
                            <th>Type</th>
                            <th>Date Suppression</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredLinks.length === 0 ? (
                            <tr>
                                <td colSpan="5">Aucun lien supprimé.</td>
                            </tr>
                        ) : (
                            filteredLinks.map((link) => (
                                <tr key={link.id}>
                                    <td>{link.ambassadeur_prenom} {link.ambassadeur_nom}</td>
                                    <td>{`https://gracedesalpes.com/r/${link.code_court}`}</td>
                                    <td>{link.type_lien === 'defaut' ? 'Par Défaut' : 'Personnalisé'}</td>
                                    <td>{link.date_suppression ? new Date(link.date_suppression).toLocaleDateString() : 'N/A'}</td>
                                    <td className="action-cell">
                                        <button onClick={() => handleRestoreClick(link)} className="action-btn btn-restore" title="Restaurer">
                                            <FaUndo /> Restaurer
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <RestoreCustomLinkModal
                isOpen={showRestoreCustomLinkModal}
                onClose={() => setShowRestoreCustomLinkModal(false)}
                onRestore={onRestoreLink}
                link={linkToRestore}
            />
        </div>
    );
};

export default DeletedLinksTable;